import { useEffect } from "react"
import { useParams } from "wouter"
import TopBar from "@/components/layout/TopBar"
import Sidebar from "@/components/layout/Sidebar"
import ProductionRail from "@/components/layout/ProductionRail"
import OverviewView from "@/pages/OverviewView"
import DevelopView from "@/pages/DevelopView"
import PlanView from "@/pages/PlanView"
import ProduceView from "@/pages/ProduceView"
import FinishView from "@/pages/FinishView"
import PublishView from "@/pages/PublishView"
import { useStudioStore } from "@/store/studio"
import CreditDialog from "@/components/CreditDialog"
import Toast from "@/components/Toast"

export default function StudioPage() {
  const params = useParams<{ tab?: string }>()
  const tab = params.tab || "home"
  const store = useStudioStore()
  const setView = store.setView

  useEffect(() => {
    setView(tab)
  }, [tab, setView])

  const renderView = () => {
    switch (tab) {
      case "home":
      case "":
        return <OverviewView />
      case "develop":
        return <DevelopView />
      case "plan":
        return <PlanView />
      case "produce":
        return <ProduceView />
      case "finish":
        return <FinishView />
      case "publish":
        return <PublishView />
      default:
        return <OverviewView />
    }
  }

  return (
    <div className="min-h-screen bg-[#08090d]">
      <TopBar />
      <div className="flex min-w-0">
        <Sidebar />
        <main id="studio-workspace" className="flex-1 min-w-0 min-h-[calc(100vh-3.5rem)] pb-20 lg:pb-0">
          <ProductionRail />
          <div className="px-3 py-4 sm:p-5 xl:p-6 max-w-[1400px] mx-auto">
            {renderView()}
          </div>
        </main>
      </div>
      <CreditDialog />
      <Toast />
    </div>
  )
}
